import api from '@/api/hm'
import { cleanHmToken, setHmToken } from '@/utils/hmToken'

const state = {
  contentHideStatus: { INTERVIEW: ['item'], SCREENING: ['item'] },
  tabStatus: { INTERVIEW: 'todo', SCREENING: 'todo' }
}

const actions = {
  getHMDashBoardData (context) {
    return api.getHMDashBoardData()
  },
  async createHmPassword ({ commit }, { resetCode, formData }) {
    const resp = await api.createHmPassword(resetCode, formData)
    if (resp.token) {
      setHmToken(resp.token)
    }
    return resp
  },
  forgetHmPassword (context, formData) {
    return api.forgetHmPassword(formData)
  },
  getHmInfoByResetCode (context, resetCode) {
    return api.getHmInfoByResetCode(resetCode)
  },
  async hmLogin (context, params) {
    const resp = await api.hmLogin(params)
    setHmToken(resp.token)
    return resp
  },
  async hrAutoLoginHm (context) {
    const token = await api.hrAutoLoginHm()
    setHmToken(token)
    return token
  },
  getHmInfo (context) {
    return api.getHmInfo()
  },
  async switchRootCompany (context, rootCompanyId) {
    const resp = await api.switchRootCompany(rootCompanyId)
    setHmToken(resp.token)
    return resp
  },
  resolveRootCompany (context, params) {
    return api.resolveRootCompany(params)
  },
  setToken (context, value = null) {
    setHmToken(value)
  },
  changeContentHideStatus ({ commit }, params) {
    commit('CHANGE_CONTENT_HIDE_STATUS', params)
  },
  changeTabStatus ({ commit }, params) {
    commit('TAB_STATUS', params)
  },
  cleanHMToken () {
    cleanHmToken()
  },
  getRatingInfoByInviteCode (context, inviteCode) {
    return api.getRatingInfoByInviteCode(inviteCode)
  },
  getInterviewInfoByInviteCode (context, inviteCode) {
    return api.getInterviewInfoByInviteCode(inviteCode)
  },
  saveRatingResultByInviteCode (context, { inviteCode, params }) {
    return api.saveRatingResultByInviteCode(inviteCode, params)
  },
  saveInterviewRatingResultByInviteCode (context, { inviteCode, params }) {
    return api.saveInterviewRatingResultByInviteCode(inviteCode, params)
  },
  getHmQuestionList (context, params) {
    return api.getHmQuestionList(params)
  },
  sendInviteHm (context, params) {
    return api.sendInviteHm(params)
  },
  resendInviteHm (context, params) {
    return api.resendInviteHm(params)
  },
  getHmListForInvite (context, params) {
    return api.getHmListForInvite(params)
  },
  getHMRateList (context, params) {
    return api.getHMRateList(params)
  },
  previewInviteRateEmail (context, params) {
    return api.previewInviteRateEmail(params)
  },
  getCompanyHmList (context, params) {
    return api.getCompanyHmList(params)
  },
  updateCompanyHm (context, { companyHmId, data }) {
    return api.updateCompanyHm(companyHmId, data)
  },
  saveCompanyHm (context, data) {
    return api.saveCompanyHm(data)
  },
  hmEmailValidate (context, params) {
    return api.hmEmailValidate(params)
  },
  getCompanyHm (context, companyHMId) {
    return api.getCompanyHm(companyHMId)
  },
  resetCompanyHMPasswordByHR (context, companyHmId) {
    return api.resetCompanyHMPasswordByHR(companyHmId)
  },
  getInterviewRecordInfo (context, { interviewUuid, params }) {
    return api.getInterviewRecordInfo(interviewUuid, params)
  },
  updateInterviewRecordInfo (context, { interviewUuid, data }) {
    return api.updateInterviewRecordInfo(interviewUuid, data)
  },
  updateInterviewRecordOnlineInfo (context, { interviewUuid, data }) {
    return api.updateInterviewRecordOnlineInfo(interviewUuid, data)
  },
  getHMInterviewRateList (context, params) {
    return api.getHMInterviewRateList(params)
  },
  getScheduleList (context, params) {
    return api.getScheduleList(params)
  },
  hmCheckMicrosoftGraphAuth () {
    return api.hmCheckMicrosoftGraphAuth()
  },
  hmCreateOnlineMeetingEvent ({ commit }, params) {
    return api.hmCreateOnlineMeetingEvent(params)
  },
  hmUpdateOnlineMeetingEvent ({ commit }, params) {
    return api.hmUpdateOnlineMeetingEvent(params)
  },
  hmDeleteOnlineMeetingEvent ({ commit }, { eventId }) {
    return api.hmDeleteOnlineMeetingEvent(eventId)
  }
}

const mutations = {
  CHANGE_CONTENT_HIDE_STATUS (state, params) {
    state.contentHideStatus[params.type] = params.value
  },
  TAB_STATUS (state, params) {
    state.tabStatus[params.type] = params.tab
  }
}

const getters = {
  getInviteCode (state) {
    return state.inviteCode
  },
  contentHideStatus (state) {
    return state.contentHideStatus
  },
  tabStatus (state) {
    return state.tabStatus
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
